import styled from "styled-components";

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
`;
